import * as libHabitat from './habitat';
export const prefix = 'modelportfolios/'; // tech debt lowercase `p` in portfolios
export const IDToName = (id) => {
    return libHabitat.IDToName(id) + '/' + prefix + id.modelPortfolioID;
};
